import React from "react";
import Eligibility from "./Eligibility/Eligibility.jsx";
import LoanEstimator from "./Estimator/LoanEstimator.jsx";
import Tailor from "./Tailor/Tailor.jsx";
import Insights from "./Insights/Insights.jsx";
// import Navbar from "../Navbar";
// import Eligibility from "./Eligibility/Eligibility";
// import Estimator from "./Estimator/LoanEstimator";
// import Tailor from "./Tailor/Tailor";
// import Insights from "./Insights/Insights";
// import Footer from "./Footer";

const PLDashboardPage = () => {
  return (
    <>
      {/* <Navbar /> */}
      <Eligibility />
      <LoanEstimator />
      <Tailor />
      <Insights />
      {/* <Footer /> */}
    </>
  );
};

export default PLDashboardPage;
